import Button, * as Btn from '@lib/components/Button';
import TitleBar, * as ITitleBar from '@lib/components/TitleBar';
import ErrorMessage from 'components/ErrorMessage';
import ListItem from 'components/ListItem';
import { StatusProps } from 'containers/Status';
import * as React from 'react';
import { INativeNavigator } from 'types';
import { isTensionInRange } from 'util/util';
import './Status.css';

export interface Info {
  key: string;
  value: string;
}

class Status extends React.Component<StatusProps, object> {

  public constructor(props: StatusProps) {
    super(props);
  }

  /**
   * Fired when user clicks on "Status" button
   * @param state 
   * @param event 
   */
  public onUpdate(event: React.MouseEvent<HTMLDivElement>) {
    if (this.props.lastM1 !== undefined && this.props.lastM1 !== '' &&
      this.props.lastM2 !== undefined && this.props.lastM2 !== '' &&
      this.props.site !== undefined && this.props.site!.device !== undefined &&
      this.props.site!.device!.m1 !== undefined && this.props.site!.device!.m2 !== undefined &&
      (this.props.site!.device!.m1! < this.props.lastM1 ||
        this.props.site!.device!.m2! < this.props.lastM2)) {
      this.props.onUpdate(this.props.site!.device!.id);
    } else {
      /* tslint:disable:no-empty */
      (navigator as INativeNavigator).notification.alert(this.props.i18n.Status.alreadyUptodate, () => { }, 'Smart TX');
    }
  }

  /**
   * Fired when user click on menu hamburger button
   * @param event 
   */
  public onMenuClick(event: React.MouseEvent<HTMLDivElement>) {
    this.props.onGoHome();
  }

  public dummyClick(event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
  }


  public render() {

    const i18n = this.props.i18n;

    if (this.props.site === undefined || this.props.site.device === undefined) {
      window.location.pathname = '/';
      window.location.hash = '';
      return null;
    }

    const infos: Info[] = [];

    if (this.props.site !== undefined && this.props.site.device !== undefined) {

      infos.push({ key: this.props.i18n.Status.appVersion, value: '1.3.5' });

      infos.push({ key: this.props.i18n.Status.lastDate, value: this.props.site.lastValueTime!.toLocaleString('fr-FR', { timeZone: "Europe/Paris" }) });
      if (this.props.site.device.connected) {
        infos.push({ key: this.props.i18n.Status.connectionType, value: this.props.site.device.connectionType! });
      } else {
        infos.push({ key: this.props.i18n.Status.connectionType, value: this.props.site.device.connectionType! });
      }
      // Gsm informations
      if (this.props.site.device.gsmStatus !== undefined) {
        let operator = this.props.site.device.gsmStatus.operator;
        if (this.props.site.device!.gsmStatus!.network !== undefined && this.props.site.device!.gsmStatus!.network !== '') {
          operator += ' (' + this.props.site.device!.gsmStatus!.network + ')';
        }
        infos.push({ key: this.props.i18n.Status.gsmOperator, value: operator });

        // Phone number
        if (this.props.site.device!.gsmStatus!.number !== undefined) {
          infos.push({ key: this.props.i18n.Status.gsmNumber, value: this.props.site.device!.gsmStatus!.number! });
        }

      }

      // Power information
      if (this.props.site.power !== undefined && this.props.site.power[0] !== undefined && isTensionInRange(this.props.site.power[0].value)) {
        let level = '';
        if (this.props.site.power[0].value < 1 || this.props.site.power[0].value > 50) {
          level = level = this.props.i18n.Status.battery_unknown;
        }
        else if (this.props.site.power[0].value >= 9.6) {
          level = this.props.i18n.Status.battery_good;
        }
        else if (this.props.site.power[0].value < 9.2) {
          level = this.props.i18n.Status.battery_poor;
        }
        else {
          level = this.props.i18n.Status.battery_medium;
        }
        infos.push({ key: this.props.i18n.Status.battery, value: level });
      } else {
        infos.push({ key: this.props.i18n.Status.battery, value: this.props.i18n.Status.battery_unknown });
      }
      if (this.props.site.power !== undefined && this.props.site.power[1] !== undefined && isTensionInRange(this.props.site.power[1].value)) {
        infos.push({ key: this.props.i18n.Status.sector, value: this.props.site.power[1].value.toString() + ' V' });
      } else {
        infos.push({ key: this.props.i18n.Status.sector, value: this.props.i18n.Status.battery_unknown });
      }


      infos.push({ key: this.props.i18n.Status.mac, value: this.props.site.device!.mac });
      infos.push({ key: this.props.i18n.Status.ipAddress, value: this.props.site.device!.ip! });
      if (this.props.site.device.connected && this.props.site.device.connectionType === 'IP') {
        infos.push({ key: this.props.i18n.Status.remoteIp, value: this.props.site.device!.remoteAddress! });
      }


      infos.push({ key: this.props.i18n.Status.m1Version, value: this.props.site.device!.m1! });
      infos.push({ key: this.props.i18n.Status.m2Version, value: this.props.site.device!.m2! });

      if (this.props.isAdmin) {
        const apn = this.props.site.device!.gsmStatus!.apn + ' / ' + this.props.site.device!.gsmStatus!.user + ' / ' + this.props.site.device!.gsmStatus!.password;
        infos.push({ key: 'APN', value: apn });
      }

    }

    return (
      <div className="standardPage status" >
        <TitleBar
          leftIcon={ITitleBar.ICO_CHEVRON_LEFT}
          onLeftButtonClick={this.onMenuClick.bind(this, this.state)}
          title={i18n.Status.title}
        />

        <ErrorMessage message={i18n.Common.errors[this.props.errorMessage]} />

        <div id="infoList">
          {infos.map((info: Info) => (
            <ListItem icoClass={'none'} title={info.key} detail={info.value} key={info.key} onClick={this.dummyClick} />
          ))}
        </div>
        {(this.props.site.device.connected && this.props.site.device.connectionType === 'IP' && false) &&
          <div id="footerButton">
            <Button label={i18n.Status.update} type={Btn.BTN_TYPE_LARGE} onClick={this.onUpdate.bind(this, this.state)} />
          </div>
        }

      </div >

    );
  }
}

export default Status;



// WEBPACK FOOTER //
// ./src/pages/Status.tsx